import React from 'react';
import { Chip } from '@mui/material';
import { formatTimeAgo } from 'app/shared/devices/deviceDisplay';

// Presentación común de los equipos de Xpit AI Vision en superadmin.

export const describeError = (error, fallback) => {
  const errors = error?.response?.data?.errors;
  if (Array.isArray(errors) && errors.length) return errors.join(', ');
  const status = error?.response?.status;
  return status ? `${fallback} (error ${status}).` : `${fallback}.`;
};

export const formatDateTime = (isoTime) => {
  if (!isoTime) return '-';
  const time = new Date(isoTime);
  if (Number.isNaN(time.getTime())) return '-';
  return time.toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' });
};

// "En línea" si el último estado tiene menos de 10 minutos (lo calcula el backend).
export const OnlineChip = ({ device, size = 'small' }) => (
  <Chip
    size={size}
    color={device?.online ? 'success' : 'default'}
    variant={device?.online ? 'filled' : 'outlined'}
    label={device?.online ? 'En línea' : `Sin conexión${device?.last_seen_at ? ` · ${formatTimeAgo(device.last_seen_at)}` : ''}`}
  />
);

export const PASSWORD_STATES = {
  pending: { label: 'Pendiente de envío', color: 'warning' },
  sent: { label: 'Enviada al equipo', color: 'info' },
  applied: { label: 'Aplicada en el equipo', color: 'success' },
};

export const formatUptime = (seconds) => {
  if (seconds === null || seconds === undefined) return '-';
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) return `${days} d ${hours} h`;
  if (hours > 0) return `${hours} h ${minutes} min`;
  return `${minutes} min`;
};

export const formatNumber = (value, unit = '', decimals = 0) => {
  if (value === null || value === undefined || value === '') return '-';
  const number = Number(value);
  if (!Number.isFinite(number)) return `${value}`;
  return `${number.toFixed(decimals)}${unit}`;
};

export const OBJECT_CLASS_LABELS = { person: 'Personas', vehicle: 'Vehículos', box: 'Cajas' };
export const ANALYTIC_TYPE_LABELS = { line_crossing: 'Conteo por línea' };
